import Vue from 'vue'
import App from './App.vue'

import router from './routes'

import './plugins/vuetify'

import './plugins/socket.io'

import axios from 'axios'
import axiosPlugin from './plugins/axios'

import  './plugins/ckeditor'

Vue.use({
  install(Vue) {
    Vue.prototype.$axios = axiosPlugin(axios)
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
